<template>
  <div class="ec-container">
    <div class="px-160 ec-container">
      <EcomHeader :categories="categories" />

      <BreadcrumbCpn :breadcrumb="breadcrumb" />

      <div class="ec-body pb-5" v-loading="isLoading">
        <div class="ec-body-list mb-4">
          <div class="row">
            <div class="col-xl-9">
              <div class="bg-white rounded-xl p-3 mb-4 mb-xl-0 xl:h-full">
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3 mb-lg-0 h-full">
                      <img class="w-full h-full border rounded-lg overflow-hidden object-contain"
                        :src="product.primary_image" :alt="product.name"
                        @error="(e) => appUtils.onHandleErrorLoadImage(e)" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h1 class="fs-24">{{ product.name }}</h1>
                    <div class="px-3 py-2 mb-3 rounded-lg bg-blue-50 bg-opacity-70">
                      <div class="flex fs-24 fw-700 mb-0 items-center whitespace-nowrap">
                        <span class="txt-pri">{{ appUtils.numberFormat(price) }}đ /
                          {{ variant }}</span>
                        <!-- <span
                          v-if="
                            product.default_price && product.default_unit_name
                          "
                          class="fs-18 fw-500 txt-gey-900"
                        >/ {{ product.default_unit_name }}</span>-->
                      </div>
                      <div class="flex items-center" v-if="product.old_price">
                        <div class="fs-16 txt-grey-500 mb-0 text-decoration-line-through mr-2">
                          {{
        product.old_price
          ? `${appUtils.numberFormat(
            product.old_price
          )} VNĐ`
          : `&nbsp;`
      }}
                        </div>
                        <b-badge v-show="false" pill class="bg-red-50 border-1 border-solid border-red-500">
                          <span class="text-red-600 fs-14">90%</span>
                        </b-badge>
                      </div>
                    </div>
                    <div class="mb-3 flex">
                      <label class="mr-1 font-bold">Danh mục:</label>
                      <!-- <div class="flex flex-wrap">
                        <p
                          @click="goToCategory(item)"
                          v-for="item in listCategories"
                          :key="item.id"
                          class="cursor-pointer category mr-1"
                        >
                          <span>{{item.name}}</span>
                          <span class="comma ml-0">,</span>
                        </p>
                      </div>-->
                      <a class="cursor-pointer category" @click="goToCategory(product.category)">{{ product.category &&
        product.category.name }}</a>
                    </div>
                    <b-card-text v-if="product.type === PRODUCT_TYPE.PRODUCT">
                      <span class="font-medium" style="margin-right: 4px">Tình trạng -</span>
                      <span class="text-success" v-if="balance > 0">Còn hàng</span>
                      <span class="text-warning" v-else>Hết hàng</span>
                    </b-card-text>
                    <div class="mb-3" v-if="product.type === PRODUCT_TYPE.PRODUCT">
                      <label class="mr-1 font-bold">Dạng bào chế:</label>
                      <span>{{
        product.product_dosage_form &&
        product.product_dosage_form.name
      }}</span>
                    </div>
                    <div class="mb-3" v-if="product.type === PRODUCT_TYPE.PRODUCT">
                      <label class="mr-1 font-bold">Quy cách đóng gói:</label>
                      <span>{{
        product.product_specification &&
        product.product_specification.name
      }}</span>
                    </div>
                    <div class="mb-3" v-if="product.type === PRODUCT_TYPE.PRODUCT">
                      <label class="mr-1 font-bold">Thành phần:</label>
                      <span>{{ product.ingredient }}</span>
                    </div>
                    <div class="mb-3" v-if="product.type === PRODUCT_TYPE.PRODUCT">
                      <label class="mr-1 font-bold">Chỉ định:</label>
                      <span>{{ product.indication }}</span>
                    </div>
                    <div class="mb-3" v-if="product.type === PRODUCT_TYPE.PRODUCT">
                      <label class="mr-1 font-bold">Chống chỉ định:</label>
                      <span>{{ product.contraindicated }}</span>
                    </div>
                    <div class="mb-3">
                      <label class="mr-1 font-bold">Mô tả ngắn:</label>
                      <span>{{ product.short_desc }}</span>
                    </div>
                    <div class="mb-3" v-if="product.type === PRODUCT_TYPE.PRODUCT">
                      <label class="mr-1 font-bold">Thương hiệu:</label>
                      <span>{{ product.brand && product.brand.name }}</span>
                    </div>
                    <div class="mb-3" v-if="product.type === PRODUCT_TYPE.PRODUCT">
                      <label class="mr-1 font-bold">Xuất xứ:</label>
                      <span>{{
        product.product_origin && product.product_origin.name
      }}</span>
                    </div>
                    <div class="mb-3">
                      <label class="mr-1 font-bold">
                        {{
          product.type === PRODUCT_TYPE.PRODUCT
            ? "Nhà sản xuất"
            : "Nhà phân phối"
        }}:
                      </label>
                      <span>{{
          product.product_manufacture &&
          product.product_manufacture.name
        }}</span>
                    </div>
                    <hr />
                    <div class="flex items-center gap-2 text-black mb-1 choose-variant" v-if="product.product_variants">
                      <span class="font-medium">Đơn vị tính:</span>
                      <div v-for="item in product.product_variants" :key="item.id" class="flex items-center gap-3">
                        <b-form-group v-slot="{ ariaDescribedby }">
                          <b-form-radio v-model="variantActive" :aria-describedby="ariaDescribedby" :value="item">
                            <span class="text-black text-lg ml-2">{{
        item.unit_name
      }}</span>
                          </b-form-radio>
                        </b-form-group>
                      </div>
                    </div>
                    <div v-if="product.default_price &&
        product.type === PRODUCT_TYPE.PRODUCT
        " class="mb-3 hodo-el-input-amount flex items-center gap-3">
                      <span class="font-medium">Chọn số lượng:</span>
                      <div class="col-sm-6 col-lg-4">
                        <!-- <el-input
                          class="text-center cs-color"
                          placeholder="Số lượng"
                          v-model.number="amount"
                          :disabled="product.type === PRODUCT_TYPE.SERVICE"
                        >
                          <i
                            v-if="product.type === PRODUCT_TYPE.PRODUCT"
                            slot="prefix"
                            class="el-input__icon el-icon-minus border-r border-t-0 border-b-0 border-l-0 border-solid border-gray-300 txt-grey-900 cursor-pointer"
                            @click="subtract"
                          ></i>
                          <i
                            v-if="product.type === PRODUCT_TYPE.PRODUCT"
                            slot="suffix"
                            class="el-input__icon el-icon-plus border-l border-t-0 border-b-0 border-r-0 border-solid border-gray-300 txt-grey-900 cursor-pointer"
                            @click="addMore"
                          ></i>
                        </el-input>-->
                        <el-input-number size="small" :min="1" v-model="amount"></el-input-number>
                      </div>
                    </div>
                    <div v-if="product.default_price" class="row">
                      <div class="col-sm-6">
                        <button :disabled="(!balance || balance <= 0) &&
        product.type === PRODUCT_TYPE.PRODUCT
        " type="button" class="border-1 border-solid border-pri-900 bg-blue-50 text-pri-900 hover:bg-pri-900 hover:text-white transition-all duration-400 text-center w-full py-2 rounded-lg mb-3 mb-sm-0"
                          @click="
        handleClickAddToCard((isBuyNow = false), {
          product: product,
          amount: amount,
          variant: product.selected_variant.id,
        })
        ">
                          <span class="d-block py-1">
                            <span class="d-inline-block me-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 14 14">
                                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                  d="M10.946 13.5a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1m-6.5 0a.5.5 0 1 1 0-1a.5.5 0 0 1 0 1m5.158-7h-3m1.5-1.5v3M.5.5H3L3.263 3m0 0l.643 6.105A1 1 0 0 0 4.9 10h6.32a1 1 0 0 0 .97-.757l1.25-5A1 1 0 0 0 12.47 3z" />
                              </svg>
                            </span>
                            <span class="fs-16 fw-500 mb-0 align-middle">{{
        $t("lbl_add_to_cart")
      }}</span>
                          </span>
                        </button>
                      </div>
                      <div class="col-sm-6">
                        <button :disabled="(!balance || balance <= 0) &&
        product.type === PRODUCT_TYPE.PRODUCT
        " type="button" class="border-1 border-solid border-pri-900 bg-blue-50 text-pri-900 hover:bg-pri-900 hover:text-white transition-all duration-400 text-center w-full py-2 rounded-lg mb-3 mb-sm-0"
                          @click="
        handleClickAddToCard((isBuyNow = true), {
          product: product,
          amount: amount,
          variant: product.selected_variant.id,
        })
        ">
                          <span class="d-block py-1">
                            <span class="d-inline-block me-2">
                              <svg v-if="product.type === PRODUCT_TYPE.PRODUCT" width="25" height="24"
                                viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M9.75 19C9.75 19.75 9.54 20.46 9.17 21.06C8.48 22.22 7.21 23 5.75 23C4.29 23 3.02 22.22 2.33 21.06C1.96 20.46 1.75 19.75 1.75 19C1.75 16.79 3.54 15 5.75 15C7.96 15 9.75 16.79 9.75 19Z"
                                  stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path d="M4.19141 18.9995L5.18141 19.9895L7.31141 18.0195" stroke="currentColor"
                                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                  d="M18.5014 7.04997C18.2614 7.00997 18.0114 6.99998 17.7514 6.99998H7.75141C7.47141 6.99998 7.20141 7.01998 6.94141 7.05998C7.08141 6.77998 7.28141 6.52001 7.52141 6.28001L10.7714 3.02C12.1414 1.66 14.3614 1.66 15.7314 3.02L17.4814 4.78996C18.1214 5.41996 18.4614 6.21997 18.5014 7.04997Z"
                                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path
                                  d="M22.75 12V17C22.75 20 20.75 22 17.75 22H8.38C8.69 21.74 8.96 21.42 9.17 21.06C9.54 20.46 9.75 19.75 9.75 19C9.75 16.79 7.96 15 5.75 15C4.55 15 3.48 15.53 2.75 16.36V12C2.75 9.28 4.39 7.38 6.94 7.06C7.2 7.02 7.47 7 7.75 7H17.75C18.01 7 18.26 7.00999 18.5 7.04999C21.08 7.34999 22.75 9.26 22.75 12Z"
                                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                <path
                                  d="M22.75 12.5H19.75C18.65 12.5 17.75 13.4 17.75 14.5C17.75 15.6 18.65 16.5 19.75 16.5H22.75"
                                  stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                  stroke-linejoin="round" />
                              </svg>
                              <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M20.1099 17.49L14.9999 8.73V4H15.9999C16.2651 4 16.5195 3.89464 16.707 3.70711C16.8945 3.51957 16.9999 3.26522 16.9999 3C16.9999 2.73478 16.8945 2.48043 16.707 2.29289C16.5195 2.10536 16.2651 2 15.9999 2H7.9999C7.73468 2 7.48033 2.10536 7.29279 2.29289C7.10526 2.48043 6.9999 2.73478 6.9999 3C6.9999 3.26522 7.10526 3.51957 7.29279 3.70711C7.48033 3.89464 7.73468 4 7.9999 4H8.9999V8.73L3.8899 17.49C3.62444 17.9457 3.48382 18.4634 3.48219 18.9908C3.48057 19.5182 3.618 20.0367 3.88065 20.494C4.14329 20.9514 4.52186 21.3314 4.9782 21.5958C5.43453 21.8602 5.9525 21.9996 6.4799 22H17.4799C18.0073 21.9996 18.5253 21.8602 18.9816 21.5958C19.4379 21.3314 19.8165 20.9514 20.0792 20.494C20.3418 20.0367 20.4792 19.5182 20.4776 18.9908C20.476 18.4634 20.3354 17.9457 20.0699 17.49H20.1099ZM10.8599 9.49C10.9481 9.3415 10.9963 9.17268 10.9999 9V4H12.9999V9C13.0017 9.17609 13.05 9.34857 13.1399 9.5L13.9999 11H9.9999L10.8599 9.49ZM18.3799 19.49C18.2926 19.6411 18.1674 19.7668 18.0165 19.8545C17.8656 19.9422 17.6944 19.9889 17.5199 19.99H6.5199C6.34539 19.9889 6.17419 19.9422 6.02332 19.8545C5.87245 19.7668 5.74716 19.6411 5.6599 19.49C5.57213 19.338 5.52593 19.1655 5.52593 18.99C5.52593 18.8145 5.57213 18.642 5.6599 18.49L8.8299 13H15.1799L18.3799 18.5C18.4677 18.652 18.5139 18.8245 18.5139 19C18.5139 19.1755 18.4677 19.348 18.3799 19.5V19.49ZM9.9999 15C9.80212 15 9.60878 15.0586 9.44433 15.1685C9.27988 15.2784 9.15171 15.4346 9.07602 15.6173C9.00033 15.8 8.98053 16.0011 9.01912 16.1951C9.0577 16.3891 9.15294 16.5673 9.29279 16.7071C9.43265 16.847 9.61083 16.9422 9.80481 16.9808C9.99879 17.0194 10.1999 16.9996 10.3826 16.9239C10.5653 16.8482 10.7215 16.72 10.8314 16.5556C10.9413 16.3911 10.9999 16.1978 10.9999 16C10.9999 15.7348 10.8945 15.4804 10.707 15.2929C10.5195 15.1054 10.2651 15 9.9999 15ZM13.9999 16C13.8021 16 13.6088 16.0586 13.4443 16.1685C13.2799 16.2784 13.1517 16.4346 13.076 16.6173C13.0003 16.8 12.9805 17.0011 13.0191 17.1951C13.0577 17.3891 13.1529 17.5673 13.2928 17.7071C13.4326 17.847 13.6108 17.9422 13.8048 17.9808C13.9988 18.0194 14.1999 17.9996 14.3826 17.9239C14.5653 17.8482 14.7215 17.72 14.8314 17.5556C14.9413 17.3911 14.9999 17.1978 14.9999 17C14.9999 16.7348 14.8945 16.4804 14.707 16.2929C14.5195 16.1054 14.2651 16 13.9999 16Z"
                                  fill="currentColor" />
                              </svg>
                            </span>
                            <span class="fs-16 fw-500 mb-0 align-middle">
                              {{
        $t(
          product.type === PRODUCT_TYPE.PRODUCT
            ? "Mua ngay"
            : "lbl_service_required"
        )
      }}
                            </span>
                          </span>
                        </button>
                      </div>
                      <!-- <div
                        v-if="product.type === PRODUCT_TYPE.PRODUCT"
                        class="col-sm-6"
                      >
                        <button
                          type="button"
                          class="border-1 border-solid border-pri-700 bg-pri text-white hover:bg-pri-900 transition-all duration-400 text-center w-full py-2 rounded-lg"
                          @click="handleClickAddToCard((isBuyNow = true))"
                        >
                          <span class="d-block py-1">
                            <span class="d-inline-block me-2">
                              <svg
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.75 19C9.75 19.75 9.54 20.46 9.17 21.06C8.48 22.22 7.21 23 5.75 23C4.29 23 3.02 22.22 2.33 21.06C1.96 20.46 1.75 19.75 1.75 19C1.75 16.79 3.54 15 5.75 15C7.96 15 9.75 16.79 9.75 19Z"
                                  stroke="currentColor"
                                  stroke-width="1.5"
                                  stroke-miterlimit="10"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M4.19141 18.9995L5.18141 19.9895L7.31141 18.0195"
                                  stroke="currentColor"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M18.5014 7.04997C18.2614 7.00997 18.0114 6.99998 17.7514 6.99998H7.75141C7.47141 6.99998 7.20141 7.01998 6.94141 7.05998C7.08141 6.77998 7.28141 6.52001 7.52141 6.28001L10.7714 3.02C12.1414 1.66 14.3614 1.66 15.7314 3.02L17.4814 4.78996C18.1214 5.41996 18.4614 6.21997 18.5014 7.04997Z"
                                  stroke="currentColor"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M22.75 12V17C22.75 20 20.75 22 17.75 22H8.38C8.69 21.74 8.96 21.42 9.17 21.06C9.54 20.46 9.75 19.75 9.75 19C9.75 16.79 7.96 15 5.75 15C4.55 15 3.48 15.53 2.75 16.36V12C2.75 9.28 4.39 7.38 6.94 7.06C7.2 7.02 7.47 7 7.75 7H17.75C18.01 7 18.26 7.00999 18.5 7.04999C21.08 7.34999 22.75 9.26 22.75 12Z"
                                  stroke="currentColor"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M22.75 12.5H19.75C18.65 12.5 17.75 13.4 17.75 14.5C17.75 15.6 18.65 16.5 19.75 16.5H22.75"
                                  stroke="currentColor"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </span>
                            <span class="fs-16 fw-500 mb-0 align-middle"
                              >Mua ngay</span
                            >
                          </span>
                        </button>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3">
              <div class="bg-white rounded-xl p-3 md:h-full">
                <b-card no-body tag="article" class="xl:mb-2 border-0 rounded-t-lg overflow-hidden">
                  <div class="row">
                    <div class="col-sm-4 col-lg-3 col-xl-12">
                      <b-card-img v-if="Object.keys(product).length"
                        :src="(product.brand && product.brand.url) || 'image'" alt="Image"
                        @error="(e) => appUtils.onHandleErrorLoadImage(e)"></b-card-img>
                    </div>
                    <div class="col-sm-8 col-lg-9 col-xl-12">
                      <div class="xl:mt-2 xl:border-top">
                        <div class="mb-2">
                          <label class="fs-12">Nhà cung cấp</label>
                          <h4 class="fs-14" :style="product.supplier && product.supplier.name
          ? {}
          : {
            borderBottom: `1px dashed #c0c0c0`,
            width: `100%`,
            paddingTop: `16px`,
          }
        ">
                            {{ product.supplier && product.supplier.name }}
                          </h4>
                        </div>
                        <!-- <div class="flex fs-14 mb-2">
                          <div class="leading-none txt-pri w-4 h-4 mr-2">
                            <svg
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11.7466 7.16667C11.46 7.16667 11.2333 6.93334 11.2333 6.65334C11.2333 6.40667 10.9866 5.89334 10.5733 5.44667C10.1666 5.01334 9.71998 4.76 9.34665 4.76C9.05998 4.76 8.83331 4.52667 8.83331 4.24667C8.83331 3.96667 9.06665 3.73334 9.34665 3.73334C10.0133 3.73334 10.7133 4.09334 11.3266 4.74C11.9 5.34667 12.2666 6.1 12.2666 6.64667C12.2666 6.93334 12.0333 7.16667 11.7466 7.16667Z"
                                fill="currentColor"
                              />
                              <path
                                d="M14.1534 7.16665C13.8667 7.16665 13.64 6.93331 13.64 6.65331C13.64 4.28665 11.7134 2.36665 9.35336 2.36665C9.06669 2.36665 8.84003 2.13331 8.84003 1.85331C8.84003 1.57331 9.06669 1.33331 9.34669 1.33331C12.28 1.33331 14.6667 3.71998 14.6667 6.65331C14.6667 6.93331 14.4334 7.16665 14.1534 7.16665Z"
                                fill="currentColor"
                              />
                              <path
                                d="M7.36665 9.96665L6.13331 11.2C5.87331 11.46 5.45998 11.46 5.19331 11.2066C5.11998 11.1333 5.04665 11.0666 4.97331 10.9933C4.28665 10.3 3.66665 9.57331 3.11331 8.81331C2.56665 8.05331 2.12665 7.29331 1.80665 6.53998C1.49331 5.77998 1.33331 5.05331 1.33331 4.35998C1.33331 3.90665 1.41331 3.47331 1.57331 3.07331C1.73331 2.66665 1.98665 2.29331 2.33998 1.95998C2.76665 1.53998 3.23331 1.33331 3.72665 1.33331C3.91331 1.33331 4.09998 1.37331 4.26665 1.45331C4.43998 1.53331 4.59331 1.65331 4.71331 1.82665L6.25998 4.00665C6.37998 4.17331 6.46665 4.32665 6.52665 4.47331C6.58665 4.61331 6.61998 4.75331 6.61998 4.87998C6.61998 5.03998 6.57331 5.19998 6.47998 5.35331C6.39331 5.50665 6.26665 5.66665 6.10665 5.82665L5.59998 6.35331C5.52665 6.42665 5.49331 6.51331 5.49331 6.61998C5.49331 6.67331 5.49998 6.71998 5.51331 6.77331C5.53331 6.82665 5.55331 6.86665 5.56665 6.90665C5.68665 7.12665 5.89331 7.41331 6.18665 7.75998C6.48665 8.10665 6.80665 8.45998 7.15331 8.81331C7.21998 8.87998 7.29331 8.94665 7.35998 9.01331C7.62665 9.27331 7.63331 9.69998 7.36665 9.96665Z"
                                fill="currentColor"
                              />
                              <path
                                d="M14.6467 12.22C14.6467 12.4067 14.6134 12.6 14.5467 12.7867C14.5267 12.84 14.5067 12.8933 14.48 12.9467C14.3667 13.1867 14.22 13.4133 14.0267 13.6267C13.7 13.9867 13.34 14.2467 12.9334 14.4133C12.9267 14.4133 12.92 14.42 12.9134 14.42C12.52 14.58 12.0934 14.6667 11.6334 14.6667C10.9534 14.6667 10.2267 14.5067 9.46002 14.18C8.69336 13.8533 7.92669 13.4133 7.16669 12.86C6.90669 12.6667 6.64669 12.4733 6.40002 12.2667L8.58002 10.0867C8.76669 10.2267 8.93336 10.3333 9.07336 10.4067C9.10669 10.42 9.14669 10.44 9.19336 10.46C9.24669 10.48 9.30002 10.4867 9.36002 10.4867C9.47336 10.4867 9.56002 10.4467 9.63336 10.3733L10.14 9.87332C10.3067 9.70665 10.4667 9.57999 10.62 9.49999C10.7734 9.40665 10.9267 9.35999 11.0934 9.35999C11.22 9.35999 11.3534 9.38665 11.5 9.44665C11.6467 9.50665 11.8 9.59332 11.9667 9.70665L14.1734 11.2733C14.3467 11.3933 14.4667 11.5333 14.54 11.7C14.6067 11.8667 14.6467 12.0333 14.6467 12.22Z"
                                fill="currentColor"
                              />
                            </svg>
                          </div>
                          <label
                            class="align-middle leading-none"
                            :style="
                              product.supplier && product.supplier.phone_number
                                ? {}
                                : {
                                    borderBottom: `1px dashed #c0c0c0`,
                                    width: `100%`,
                                  }
                            "
                          >
                            {{
                              product.supplier && product.supplier.phone_number
                            }}
                          </label>
                        </div>
                        <div class="flex fs-14">
                          <div class="leading-none txt-pri w-4 h-4 mr-2">
                            <i class="el-icon-location fs-16" />
                          </div>
                          <div
                            class="flex flex-col gap-2"
                            v-if="product.supplier"
                          >
                            <label
                              v-for="(item, index) in getAddress(
                                product.supplier.address
                              )"
                              :key="index"
                              class="align-middle leading-tight text-wrap"
                              :style="
                                product.supplier && product.supplier.address
                                  ? {}
                                  : {
                                      borderBottom: `1px dashed #c0c0c0`,
                                      width: `100%`,
                                    }
                              "
                              >{{ item }}</label
                            >
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
            </div>
          </div>
        </div>
        <div class="ec-body-list" :class="{ 'd-flex': product.is_require_form === 1 }">
          <div class="bg-white rounded-xl p-3 h-full" v-if="product.description">
            <h4 class="fs-24 border-b border-t-0 border-r-0 border-l-0 border-solid border-gray-300 mb-3">
              <span
                class="inline-block border-b-4 border-t-0 border-r-0 border-l-0 border-solid border-pri-900 pb-2">Thông
                tin sản phẩm</span>
            </h4>
            <div v-html="product.description" />
          </div>
          <div v-if="product.is_require_form === 1" class="bg-white rounded-xl p-3">
            <h4 class="fs-24 border-b border-t-0 border-r-0 border-l-0 border-solid border-gray-300 mb-3">
              <span
                class="inline-block border-b-4 border-t-0 border-r-0 border-l-0 border-solid border-pri-900 pb-2">Tài
                liệu bắt buộc</span>
            </h4>
            <div v-for="form in requireForms" :key="form.id">
              <div class="d-flex file-container">
                <div>{{ form.name }}</div>
                <div @click="handleClickFile(form.url)" class="fs-16 cs-text cursor-pointer file-btn">
                  <svg style="transform: translate(0px, -3px)" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9 10H10C10.2652 10 10.5196 9.89464 10.7071 9.70711C10.8946 9.51957 11 9.26522 11 9C11 8.73478 10.8946 8.48043 10.7071 8.29289C10.5196 8.10536 10.2652 8 10 8H9C8.73478 8 8.48043 8.10536 8.29289 8.29289C8.10536 8.48043 8 8.73478 8 9C8 9.26522 8.10536 9.51957 8.29289 9.70711C8.48043 9.89464 8.73478 10 9 10ZM9 12C8.73478 12 8.48043 12.1054 8.29289 12.2929C8.10536 12.4804 8 12.7348 8 13C8 13.2652 8.10536 13.5196 8.29289 13.7071C8.48043 13.8946 8.73478 14 9 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H9ZM20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11C13.4402 2.10576 13.4099 2.10576 13.38 2.11C13.2784 2.05174 13.1662 2.01434 13.05 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H15C14.7348 8 14.4804 7.89464 14.2929 7.70711C14.1054 7.51957 14 7.26522 14 7V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V7C12 7.79565 12.3161 8.55871 12.8787 9.12132C13.4413 9.68393 14.2044 10 15 10H18V19ZM15 16H9C8.73478 16 8.48043 16.1054 8.29289 16.2929C8.10536 16.4804 8 16.7348 8 17C8 17.2652 8.10536 17.5196 8.29289 17.7071C8.48043 17.8946 8.73478 18 9 18H15C15.2652 18 15.5196 17.8946 15.7071 17.7071C15.8946 17.5196 16 17.2652 16 17C16 16.7348 15.8946 16.4804 15.7071 16.2929C15.5196 16.1054 15.2652 16 15 16Z"
                      fill="black" />
                  </svg>
                  {{ getFileName(form.url) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalConfirmRequirePaper ref="modalConfirmRequire" @confirm="confirmRequiredPaper" />
  </div>
</template>

<script>
import store from '@/store'
import appUtils from '../../../utils/appUtils'
import EcomHeader from '../../../components/Ecom/Header.vue'
import BreadcrumbCpn from '../../../components/Layout/BreadcrumbCpn.vue'
import defaultImage from '@/assets/images/default.jpg'
import { PRODUCT_TYPE } from '../../../utils/constant'
import ModalConfirmRequirePaper from './ModalConfirmRequirePaper.vue'

export default {
  name: 'ProductDetail',
  components: {
    EcomHeader,
    BreadcrumbCpn,
    ModalConfirmRequirePaper
  },
  data () {
    return {
      isLoading: true,
      search: '',
      appUtils,
      product: {},
      amount: 1,
      breadcrumb: [
        {
          text: 'Quay lại trang mua sắm',
          to: {
            name: 'Ecommerce'
          }
        }
      ],
      defaultImage,
      PRODUCT_TYPE,
      categories: [],
      price: 0,
      variant: '',
      variantActive: {},
      balance: 0
    }
  },
  computed: {
    requireForms () {
      return this.product.order_form_config?.order_form_items
    },
    listCategories () {
      return this.product?.ecom_product_category
    },
    defaultVariants () {
      return (
        this.product?.product_variants?.find((elm) => elm.is_default === 2) ||
        this.product?.product_variants?.find(
          (elm) => elm.conversion_rate === 1
        ) ||
        this.product?.product_variants[0]
      )
    }
  },
  async created () {
    const slug = this.$route.params?.slug
    // const id = slug.split('-').slice(-1)

    await this.fetchProductDetail(slug)
    this.fetchCategories()
  },
  watch: {
    variantActive: {
      handler (value) {
        this.price =
          this.product?.product_variants?.find((elm) => elm.id === value.id)
            ?.price || 0
        const selectedVariant = this.product?.product_variants?.find(
          (elm) => elm.id === value.id
        )
        this.variant = selectedVariant?.unit_name || ''
        this.balance = selectedVariant?.qty
        this.product = {
          ...this.product,
          selected_variant: {
            ...selectedVariant
          }
        }
      }
    }
  },

  methods: {
    async fetchProductDetail (slug) {
      if (!slug) return

      await store
        .dispatch('ecommerce/fetchProductDetail', {
          slug,
          params: {}
        })
        .then((res) => {
          // console.log(res.data)
          this.product = res.data
          this.variantActive = this.defaultVariants
          this.price = this.variantActive?.price
          this.variant = this.variantActive?.unit_name
          this.breadcrumb.push({
            text: res.data.name
          })
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => (this.isLoading = false))
    },
    subtract () {
      if (this.amount <= 1) {
        this.amount = 1
        return
      }
      this.amount--
    },
    addMore () {
      this.amount++
    },
    async handleAddToCart () {
      appUtils.addToCart(
        this.product,
        this.product?.selected_variant?.id,
        this.amount
      )
      // this.$router.push({
      //   name: 'ShoppingCart'
      // })
    },
    goToCategory (item) {
      this.$router.push({
        name: 'Ecommerce',
        query: { type: this.appUtils.slugifyStr(item.name) }
      })
    },
    getFileName (string) {
      if (typeof string === 'string' && string.includes('https')) {
        const fileName = string.substring(string.lastIndexOf('/') + 1)
        if (fileName.length > 20) {
          return appUtils.truncateHash(fileName, 20)
        } else return fileName
      } else {
        if (string?.name.length > 20) {
          return appUtils.truncateHash(string?.name, 20)
        } else return string?.name
      }
    },
    handleClickFile (url) {
      window.open(url, '_blank')
    },
    handleClickAddToCard (isBuyNow, payload) {
      if (this.product.is_require_form === 1) {
        payload = {
          ...payload,
          isBuyNow: isBuyNow,
          requireForms: this.requireForms,
          variant: this.variantActive.id
        }
        this.$refs.modalConfirmRequire.showModalConfirm(true, payload)
      } else if (
        (!this.product.is_require_form || this.product.is_require_form === 2) &&
        isBuyNow
      ) {
        appUtils.addToCart(payload.product, payload.variant, payload.amount)

        if (!this.$user) {
          this.$targetRoute = '/#/shopping-cart'
          this.$router.push({ name: 'Login' }).catch((_) => { })
          return false
        }

        this.$router
          .push({
            name: 'OrderConfirm'
          })
          .catch((_) => { })
      } else {
        // if (isBuyNow) this.handleAddToCart()
        appUtils.addToCart(payload.product, payload.variant, payload.amount)
        window.$toast.open({
          message: this.$t('Thêm vào giỏ hàng thành công'),
          type: 'success'
        })
      }
    },
    confirmRequiredPaper (payload) {
      if (!payload.isBuyNow) {
        this.handleAddToCart()
      } else {
        appUtils.addToCart(
          this.product,
          this.product?.selected_variant?.id,
          this.amount
        )

        if (!this.$user) {
          this.$targetRoute = '/#/shopping-cart'
          this.$router.push({ name: 'Login' })
          return false
        }

        try {
          this.$router
            .push({
              name: 'OrderConfirm'
              // params: {
              //   id: this.oderId
              // }
            })
            .catch((_) => { })
          // const params = {
          //   package_id: 2,
          //   combo_id: 8,
          //   months: 12,
          //   voucher_code: '',
          //   description: ''
          // }
          // const res = await this.$rf
          //   .getRequest('AuthRequest')
          //   .postPackageOrder(params)

          // if (res.data) {
          //   this.oderId = res.data.id

          //   const invoices = appUtils.getInvoices(this.$user.id)

          //   invoices.push({
          //     id: uuidv4(),
          //     order_id: Number(res.data.id),
          //     products: [...this.$shoppingCart],
          //     status: ORDERS_STATUS.WAITING_CONFIRM,
          //     created_at: Date.now()
          //   })
          //   appUtils.setInvoices(invoices, this.$user.id)

          //   this.$router
          //     .push({
          //       name: 'OrderConfirm',
          //       params: {
          //         id: this.oderId
          //       }
          //     })
          //     .catch(_ => {})
          // }
        } catch (error) {
          console.log(error)
        }
      }
    },
    getAddress (address) {
      if (!address) return []

      const splitAddress = address.split('\n')

      return splitAddress
    },
    async fetchCategories () {
      this.isLoading = true

      await store
        .dispatch('ecommerce/fetchCategories', {
          sort_by: 'id',
          order: 'asc'
        })
        .then((res) => {
          this.categories = res.data?.data
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => (this.isLoading = false))
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .ec-container {
    background: rgba(247, 247, 249, 1);
    padding-top: 32px;
  }

  .ec-header {
    display: flex;
  }

  .search-wraper {
    width: calc(100% - 300px);
  }

  .hodo-el-input-amount {
    .text-center {
      input {
        text-align: center;
      }
    }

    .el-input {
      &__inner {
        // font-size: 16px;
        // padding-left: 35px;
        // padding-right: 35px;

        &:focus {

          &~.el-input__prefix,
          &~.el-input__suffix {
            .el-input__icon {
              border-color: #409eff;
            }
          }
        }
      }

      &__prefix {
        left: 0;
      }

      &__suffix {
        right: 0;
      }

      &__icon {
        width: 35px;
      }
    }
  }

  .button-shopping {
    height: 50px;
    width: 125px;
    border-radius: 9px;
    padding: 6px 12px 6px 12px;
  }

  //products
  .product-item {
    width: 100%;
    padding: 0 16px 16px 16px;
    background-color: #fff !important;
    border-radius: 16px;
  }

  .product-item-img {
    height: 179px;
    object-fit: contain;
    margin-bottom: 16px;
  }

  .product-item-name {
    height: 58px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 8px;
  }

  .product-item-sale-price,
  .product-item-price,
  .ec-body-head,
  .ec-body-list {
    margin-bottom: 16px;

    &.d-flex {
      gap: 24px;

      &>div {
        width: 50%;

        .file-container {
          align-items: center;
          gap: 20px;

          .file-btn {
            background: aliceblue;
            padding: 5px 20px;
            border-radius: 20px;
          }
        }
      }
    }
  }

  .add-to-cart-btn {
    height: 52px;
    width: 100%;
    border-radius: 12px;
    padding: 8px 12px 8px 12px;
    background: rgba(71, 109, 214, 1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .add-to-cart-btn:disabled {
    background: rgba(173, 173, 173, 1);
  }

  .el-pager .number,
  .el-pagination .btn-next i,
  .el-pagination .btn-prev i {
    font-size: 16px !important;
  }

  .el-pager li,
  .el-pagination .btn-next,
  .el-pagination .btn-prev {
    height: 45px;
    padding: 8.5px 4px;
  }

  .el-input__inner {
    // border: 2px solid rgba(213, 210, 249, 1);
    // height: 50px;
    // border-radius: 67px;
  }

  .cs-color {
    input {
      color: black !important;
    }
  }

  @media (max-width: 765px) {
    .search-wraper {
      width: 100% !important;
    }

    .cart-wraper {
      margin-left: auto;
    }

    .cs-padding {
      padding: 10px 20px;
    }

    .ec-container {
      padding-top: 12px;
    }
  }
}

.category {
  width: fit-content;
  margin-bottom: 0;

  &:hover {
    text-decoration: underline;
    color: #476dd6;
  }

  &:last-child {
    .comma {
      display: none;
    }
  }
}
</style>
